<template>
  <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="1.5" y="5.25" width="11.25" height="11.25" stroke="#2158E8" stroke-width="1.5" stroke-linecap="square"/>
    <path d="M6 1.5H16.5V12" stroke="#2158E8" stroke-width="1.5" stroke-linecap="square"/>
  </svg>
</template>